import React, { useContext, useEffect } from 'react';
import { Route, ScrollToTop, Routes } from '@thd-olt-component-react/router';
import { AppContext } from '@thd-nucleus/app-render';
import { Error } from './pages';
import { getRoutes } from './routes.js';
import './styles/app.scss';

interface AppProps {
  serverPages: unknown;
}

export const App = ({ serverPages }: AppProps) => {
  const { instance } = useContext(AppContext);
  const { currentRouteName, currentRouteComponent } = instance.router;
  const routes = getRoutes(
    currentRouteName,
    currentRouteComponent,
    serverPages,
  );

  useEffect(() => {
    document.title = 'Paint Purchase History';
  }, []);

  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route
          exact
          path={routes.home.path}
          element={<routes.home.component />}
        />
        <Route path="/error" element={<Error />} />
        <Route element={<Error />} />
      </Routes>
    </>
  );
};

App.propTypes = {};

App.defaultProps = {};
